import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { GetUsersApi, MyAccounts, UpdateUserApi } from "../../common/CommonApi";
import { Button, ButtonRow, CheckboxLabel, Dropdown, DropdownWrapper, Field, Input, Item, Label, ModalContent, ModalOverlay, Option, OptionsList, SelectBox, SelectedItems } from "../../styles/common";
import Swal from "sweetalert2";
import { options } from "../../common/common";
const Container = styled.div`
  padding: 24px;
  background: #f9fafb;
  min-height: 100vh;

  @media (max-width: 768px) {
    padding: 0;
    min-height: auto;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;

  @media (max-width: 640px) {
    align-items: stretch;
    flex-direction: column;
    gap: 12px;
  }
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
`;

const SearchInput = styled.input`
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  outline: none;
`;

const TableWrapper = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  min-width: 680px;
  border-collapse: collapse;
`;

const Th = styled.th`
  text-align: left;
  padding: 12px 16px;
  background: #f3f4f6;
`;

const Td = styled.td`
  padding: 12px 16px;
  border-top: 1px solid #eee;
`;

const ActionButton = styled.button`
  padding: 6px 12px;
  font-size: 14px;
  border-radius: 6px;
  background: #fef3c7;
  cursor: pointer;
  &:hover {
    background: #fde68a;
  }
`;


const Tag = styled.div`
  background: #007bff;
  color: white;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 6px;
`;

const RemoveBtn = styled.span`
  cursor: pointer;
  font-weight: bold;
`;

export const Access = () => {
  const [users, setUsers] = useState([]);
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [form, setForm] = useState({});

  const [roles, setRoles] = useState("");
  const [selected, setSelected] = useState([]);
  const [open, setOpen] = useState(false);

  const toggleSelection = (item) => {
    if (selected.includes(item)) {
      // remove if already selected
      setSelected(selected.filter((val) => val !== item));
    } else {
      // add new selection
      setSelected([...selected, item]);
    }
  };

  const removeItem = (item) => {
    setSelected(selected.filter((val) => val !== item));
  };

  useEffect(() => {
  GetUserList(); // only once on mount
}, []);

useEffect(() => {
  if (editingUser) {
    setForm({
      fullname: editingUser.fullname || "",
      email: editingUser.email || "",
      role: editingUser.role || "",
      permissions: editingUser.permissions || [],
      isActive: !!editingUser.isActive,
    });
    setRoles(editingUser.role || "");              // ✅ set current role
    setSelected(editingUser.permissions || []);    // ✅ set current permissions
    GetUserList(); 
  } else {
    setForm({});
    setRoles("");
    setSelected([]);
    GetUserList(); 
  }
}, [editingUser]);

  const GetUserList = async () => {
    setLoading(true)
    let response = await GetUsersApi()
    setUsers(response.data.data)
    setLoading(false)
  }

  function openEdit(user) {
    setEditingUser(user);
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
    setEditingUser(null);
  }

  function handleChange(e) {
    const { name, value, type, checked } = e.target;
    if (name === "isActive") {
      setForm((s) => ({ ...s, isActive: checked }));
    } else if (name === "permissions") {
      const perm = value;
      setForm((s) => {
        const has = s.permissions.includes(perm);
        return {
          ...s,
          permissions: has ? s.permissions.filter((p) => p !== perm) : [...s.permissions, perm],
        };
      });
    } else {
      setForm((s) => ({ ...s, [name]: value }));
    }
  }

async function saveChanges() {
  if (!form.fullname.trim()) return alert("Full name is required");
  if (!form.email.trim()) return alert("Email is required");

  try {

     const response = await fetch(
        `${process.env.REACT_APP_API_URL}edit`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id:editingUser._id,
            fullname: form.fullname,
            email: form.email,
            role: roles || form.role,
            permissions: selected.length > 0 ? selected : form.permissions,
            isActive: form.isActive,
          }),
        }
      );
    Swal.fire("User updated successfully")
    closeModal();
  } catch (err) {
    console.error("Error updating user:", err);
    alert("Failed to update user");
  }
}

  const filtered = users.filter(
    (u) => u.fullname.toLowerCase().includes(query.toLowerCase()) || u.email.toLowerCase().includes(query.toLowerCase())
  );
  return (
    <Container>
      <Header>
        <Title>Users</Title>
        <SearchInput
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search by name or email..."
        />
      </Header>

      <TableWrapper>
        <Table>
          <thead>
            <tr>
              <Th>Name</Th>
              <Th>Email</Th>
              <Th>Role</Th>
              <Th>Module</Th>
              <Th>Active</Th>
              <Th>Created</Th>
              <Th>Actions</Th>
            </tr>
          </thead>
          <tbody>
            {
          loading && 
          <tr>
          <div style={{display:"flex",justifyContent:"center"}}>
            <img src="/assets/loading.gif"/>
          </div>
          </tr>
        }
            {filtered.map((u) => (
              <tr key={u._id}>
                <Td>{u.fullname}</Td>
                <Td>{u.email}</Td>
                <Td>{u.role}</Td>
                <Td>{u.role}</Td>
                <Td>{u.isActive ? "Yes" : "No"}</Td>
                <Td>{new Date(u.createdDate).toLocaleString()}</Td>
                <Td>
                  <ActionButton onClick={() => openEdit(u)}>Edit</ActionButton>
                </Td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr>
                <Td colSpan="6">No users found.</Td>
              </tr>
            )}
          </tbody>
        </Table>
      </TableWrapper>

      {isOpen && (
        <ModalOverlay>
          <ModalContent>
            <h2>Update Admin</h2>
            <Field>
              <Label>Full Name</Label>
              <Input name="fullname" value={form.fullname} onChange={handleChange} />
            </Field>
            <Field>
              <Label>Email</Label>
              <Input name="email" value={form.email} onChange={handleChange} />
            </Field>
            <Field>
              <Label>Role</Label>
              <Dropdown value={roles} onChange={(e) => setRoles(e.target.value)}>
                <Item value="admin">Admin</Item>
                <Item value="subadmin">Sub Admin</Item>
                <Item value="moderator">Moderator</Item>
                <Item value="vendor">Vendor</Item>
              </Dropdown>
            </Field>
            <Field>
              <Label>Permissions</Label>
              <DropdownWrapper>
                <SelectBox onClick={() => setOpen(!open)}>
                  {selected.length > 0 ? selected.join(", ") : "Select options"}
                </SelectBox>
                
                {open && (
                  <OptionsList>
                    {options.map((item) => (
                      <Option key={item} onClick={() => toggleSelection(item)}>
                        {selected.includes(item) ? "✅ " : ""} {item}
                      </Option>
                    ))}
                  </OptionsList>
                )}

                <SelectedItems>
                  {selected.map((item) => (
                    <Tag key={item}>
                      {item}
                      <RemoveBtn onClick={() => removeItem(item)}>✖</RemoveBtn>
                    </Tag>
                  ))}
                </SelectedItems>
              </DropdownWrapper>
            </Field>
            <Field>
              <CheckboxLabel>
                <input
                  type="checkbox"
                  name="isActive"
                  checked={form.isActive}
                  onChange={handleChange}
                />
                Active
              </CheckboxLabel>
            </Field>
            <ButtonRow>
              <Button onClick={closeModal}>Cancel</Button>
              <Button variant="primary" onClick={saveChanges}>Save</Button>
            </ButtonRow>
          </ModalContent>
        </ModalOverlay>
      )}
    </Container>
  );
};
